import { debounce } from './utils';

/**
 * Полифил для addEventListener + возможность указать таймаут для debounce в options
 * @param {Element} el дом-элемент
 * @param {string} type тип события
 * @param {Function} listener обработчик события
 * @param {{passive, useCapture, debounce}} options настройки
 */
export const addEvent = (el, type, listener, options = {}) => {
  let _listener = listener;

  if (options.debounce) {
    // Режим debounce
    _listener = debounce(_listener, options.debounce);
  }

  el.addEventListener(type, _listener, options);
};

/**
 * DOM-ready
 */
export const ready = (fn) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
};

/**
 * Возвращает элемент текущего скрипта
 * TODO: полифил!!!
 * @return {HTMLScriptElement}
 */
export const getCurrentScript = () =>
  document.currentScript || document.getElementsByTagName('script')[document.scripts.length - 1];

// polyfill
export const currentScript = () => {
  const prop = 'currentScript';

  if (!(prop in document)) {
    Object.defineProperty(document, prop, {
      get() {
        try {
          throw new Error();
        } catch (err) {
          const stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(err.stack);
          const scriptLocation = (stackDetails && stackDetails[1]) || false;
          const currentLocation = document.location.href.replace(document.location.hash, '');
          const line = (stackDetails && stackDetails[2]) || false;

          if (scriptLocation === currentLocation) {
            const pageSource = document.documentElement.outerHTML;
            const inlineScriptSourceRegExp = new RegExp(
              `(?:[^\\n]+?\\n){0,${line - 2}}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*`,
              'i',
            );
            const inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();

            return [...document.getElementsByTagName('script')].find(
              (script) => script.innerHTML.trim() === inlineScriptSource,
            );
          }

          return [...document.getElementsByTagName('script')].find((script) => script.src === scriptLocation);
        }
      },
    });
  }
};

export const setNodeAttrs = (el, attrs) => {
  Object.entries(attrs).forEach(([key, value]) => {
    el.setAttribute(key, value);
  });
};

export const insertStyleIntoHead = (css) => {
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.appendChild(document.createTextNode(css));
  head.appendChild(style);
};

export const isElementInViewport = (el, visibilityPoint = 250) => {
  const rect = el.getBoundingClientRect();
  const bottomVisibilityPoint = rect.top + visibilityPoint;

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    bottomVisibilityPoint <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const addMediaQueryListListener = (mql, listener) => {
  if (mql.addListener) {
    mql.addListener(listener);
  } else {
    addEvent(
      window,
      'resize',
      () => {
        if (window.matchMedia(mql.media).matches !== mql.matches) {
          listener(mql);
        }
      },
      { passive: true, debounce: 30 },
    );
  }
};

export const getElementText = (el) => el.innerText || el.textContent || '';

export const getPageText = () => {
  let mainText = document.title;

  const pageDescription = document.querySelector('meta[name=description]');
  if (pageDescription) {
    mainText += ` ${pageDescription.content}`;
  }

  const headersSelectors = document.querySelectorAll('h1, h2');
  headersSelectors.forEach((header) => {
    mainText += ` ${getElementText(header)}`;
  });

  return {
    main_text: mainText,
    page_text: getElementText(document.body).substring(0, 1024 * 50),
  };
};

export const findParentA = (el) => {
  let currentElement = el;

  while (currentElement) {
    if (currentElement.tagName && currentElement.tagName.toUpperCase() === 'A') {
      return currentElement;
    }
    currentElement = currentElement.parentNode;
  }

  return null;
};
